export const staircaseConfig = {
    gameSlug: 'cognitive-reappraisal',
    category: 'lumiere_emotions',
    variable: 'duration_ms',
    startValue: 20_000,
    minValue: 6_000,
    maxValue: 30_000,
    stepSizesByPhase: [6_000, 3_000, 1_500, 1_000],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    /** 1 trial = 1 scénario (~30s) ; on cap à 8 (~ 4 min). */
    maxTrials: 8,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            reappraiseMs: 25_000,
            targetDelta: 1,
            complexity: 1,
            label: 'Scénarios simples',
        };
    }
    if (level <= 20) {
        return {
            level,
            reappraiseMs: 20_000,
            targetDelta: 1,
            complexity: 2,
            label: 'Scénarios courants',
        };
    }
    if (level <= 30) {
        return {
            level,
            reappraiseMs: 15_000,
            targetDelta: 2,
            complexity: 3,
            label: 'Scénarios moyens',
        };
    }
    if (level <= 40) {
        return {
            level,
            reappraiseMs: 10_000,
            targetDelta: 2,
            complexity: 4,
            label: 'Scénarios complexes',
        };
    }
    return {
        level,
        reappraiseMs: 6_000,
        targetDelta: 2,
        complexity: 5,
        label: 'Scénarios ambigus',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    readMs: 5_000,
    feedbackMs: 1500,
    itiMs: 1000,
};
export const paradigmMeta = {
    slug: 'cognitive-reappraisal',
    paradigm: 'Cognitive Reappraisal (Gross 1998)',
    category: 'emotion',
    goal: "Reformule l'interprétation d'une situation pour ajuster l'intensité.",
};
//# sourceMappingURL=params.js.map